import axios from "axios";

const BACKEND_URL = "https://mayak.onrender.com";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" }
});

export const adminApi = (password) =>
  axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json", "X-Admin-Password": password }
  });

export const fetchProjects = async (category) => {
  const params = category && category !== "all" ? { category } : {};
  const res = await api.get("/projects", { params });
  return res.data;
};

export const fetchStats = async () => {
  const res = await api.get("/stats");
  return res.data;
};

export const submitMessage = async (payload) => {
  const res = await api.post("/messages", payload);
  return res.data;
};

export const adminLogin = async (password) => {
  const res = await api.post("/admin/login", { password });
  return res.data;
};
